import axios from 'axios';
const API_URL = process.env.REACT_APP_API_URL;

const SubscriptionService = {

  createSubscription: async (subscriptionData) => {
    try {
      const response = await axios.post(`${API_URL}/Subscription/CreateSubscription/`, subscriptionData);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  getSubscriptionById: async (id) => {
    try {
      const response = await axios.get(`${API_URL}/Subscription/GetSubscriptionById/${id}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

    getSubscriptionsByClientId: async (clientId) => {
        try {
          const response = await axios.get(`${API_URL}/Subscription/GetSubscriptionsByClientId/${clientId}`);
          return response.data.$values;
        } catch (error) {
          console.error(`Error fetching properties with clientId ${clientId}: `, error);
          throw error;
        }
      }, 

      updateSubscription: async (id, subscriptionData) => {
        try {
          const response = await axios.put(`${API_URL}/Subscription/UpdateSubscription/${id}`, subscriptionData);
          return response.data;
        } catch (error) {
          throw error;
        }
      },

      deleteSubscription: async (id) => {
        try {
          await axios.delete(`${API_URL}/Subscription/DeleteSubscription/${id}`);
        } catch (error) {
          throw error;
        }
      },

      getAllSubscriptionPlans: async () => {
        try { 
          const response = await axios.get(`${API_URL}/SubscriptionPlan/GetAllSubscriptionPlans`);
          return response.data.$values;
        } catch (error) {
          throw error;
        }
      },

};
export default SubscriptionService;